/**
 * @file useDocumentsRegistry.ts
 * @description Данные реестра документов (phase19.31, часть 3): страница
 * документов по фильтрам из адреса (`useUrlRegistry`), постранично на сервере.
 */

import { useUrlRegistry, type UrlRegistrySpec, type UrlRegistryState } from "../useUrlRegistry";
import {
  parseDocumentsQuery,
  resetDocumentsQuery,
  toListDocumentsParams,
  writeDocumentsQuery,
  type DocumentsRegistryQuery,
} from "./documents-query";
import { listDocuments, type DocumentDto } from "../../../lib/api-crm";

/** Тексты ошибок: без списка и со списком на экране. */
export const DOCUMENTS_ERROR_TEXT = {
  empty: "Не удалось загрузить документы. Проверьте связь и попробуйте ещё раз",
  stale: "Не удалось обновить список, данные могут быть устаревшими",
} as const;

const loadDocuments = (query: DocumentsRegistryQuery) => listDocuments(toListDocumentsParams(query));

const SPEC: UrlRegistrySpec<DocumentsRegistryQuery, DocumentDto> = {
  parse: parseDocumentsQuery,
  write: writeDocumentsQuery,
  load: loadDocuments,
  reset: resetDocumentsQuery,
  errorText: DOCUMENTS_ERROR_TEXT,
};

export function useDocumentsRegistry(): UrlRegistryState<DocumentsRegistryQuery, DocumentDto> {
  return useUrlRegistry(SPEC);
}
